import React, { useContext, useState } from "react";
import { Location } from "history";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SubNavigationItems, { SubNavigationItemProps } from "go-app/components/Navigation/SubNavigationItems";
import { ReactComponent as EditSVG } from "go-core/images/svg/actions/edit.svg";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { StocktakingDraftApi } from "../../../../../../../../../../../services/Api/Organization/types";
import { StocktakingContext } from "../../../../Preview";
import ChangeStocktakingDraftNameModal from "./ChangeStocktakingDraftNameModal";

interface Props {
	stocktakingDrafts: StocktakingDraftApi[];
	handleUpdateStocktakingDraft: (index: number, stocktakingDraft: StocktakingDraftApi) => void;
}

const StocktakingDraftsMenuNavigation = ({ stocktakingDrafts, handleUpdateStocktakingDraft }: Props) => {
	const { stocktaking } = useContext(StocktakingContext);
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();
	const prefix = `/${organization.id}/stocktakings/${stocktaking.id}/drafts`;
	const [stocktakingDraftToUpdate, setStocktakingDraftToUpdate] = useState<StocktakingDraftApi | undefined>();

	const stocktakingDraftItems = stocktakingDrafts.map((draft) => ({
		title: draft.name,
		route: `${prefix}/${draft.id}`,
		subtitle: t(`enums.stocktaking.drafts.type.${draft.type}`),
		icon: (
			<EditSVG
				className="edit-icon"
				onClick={(event) => {
					setStocktakingDraftToUpdate(draft);
					event.preventDefault();
				}}
			/>
		),
	}));

	const navigationDivider: SubNavigationItemProps = {
		title: "",
		route: "",
		divider: true,
	};

	const items: SubNavigationItemProps[] = [
		{
			title: t("lib:common.word.summary"),
			route: prefix,
			isActiveRoute: (_, location: Location) => location.pathname.endsWith("drafts"),
		},
		navigationDivider,
		...stocktakingDraftItems,
		navigationDivider,
	];

	return (
		<div className="w-100">
			<SubNavigationItems title={""} items={items} />
			{!!stocktakingDraftToUpdate && (
				<ChangeStocktakingDraftNameModal
					isShown={!!stocktakingDraftToUpdate}
					onHide={() => setStocktakingDraftToUpdate(undefined)}
					stocktakingDraft={stocktakingDraftToUpdate}
					stocktakingId={stocktaking.id}
					handleSuccessAction={handleUpdateStocktakingDraft}
					index={stocktakingDrafts.indexOf(stocktakingDraftToUpdate)}
				/>
			)}
		</div>
	);
};

export default StocktakingDraftsMenuNavigation;
